module.exports = __webpack_public_path__ + "static/media/your-app-icon.d1169860.svg";